var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-users","titulo":"DESIGNAÇÃO DE GESTORES"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Gerentes_GestoresDesignados' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }